// removed by extract-text-webpack-plugin
module.exports = {"radar":"antd-pro-charts--radar-radar","legend":"antd-pro-charts--radar-legend","legendItem":"antd-pro-charts--radar-legendItem","dot":"antd-pro-charts--radar-dot"};


//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/src/components/Charts/Radar/index.less
// module id = 587
// module chunks = 0